import { render, staticRenderFns } from "./Homekind.vue?vue&type=template&id=40f15884&scoped=true"
import script from "./Homekind.vue?vue&type=script&lang=js"
export * from "./Homekind.vue?vue&type=script&lang=js"
import style0 from "./Homekind.vue?vue&type=style&index=0&id=40f15884&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f15884",
  null
  
)

export default component.exports